import React from "react";

import Charts from "../../../Charts";

const ChartUsers = props => (
  <Charts
    type="pie"
    title=""
    data={{
      labels: Object.keys(props.data),
      datasets: [
        {
          data: Object.keys(props.data).map(item => props.data[item]),
          backgroundColor: [
            "rgba(255, 99, 132, 0.2)",
            "rgba(75, 192, 192, 0.2)",
            "rgba(232, 151, 40, 0.2)",
            "rgba(28, 49, 244, 0.2)",
            "rgba(139, 71, 201, 0.2)",
            "rgba(204, 164, 69, 0.2)",
            "rgba(39, 233, 208, 0.2)"
          ],
          borderColor: [
            "rgba(255, 99, 132, 1)",
            "rgba(75, 192, 192, 1)",
            "rgba(232, 151, 40, 1)",
            "rgba(28, 49, 244, 1)",
            "rgba(139, 71, 201, 1)",
            "rgba(204, 164, 69, 1)",
            "rgba(39, 233, 208, 1)"
          ],
          borderWidth: 1
        }
      ]
    }}
  />
);

export default ChartUsers;
